import request from "@/utils/request";

export function createSchedule(data) {
  return request({
    url: "/mgr/calendar/create",
    method: "post",
    data,
  });
}

export function updateSchedule(data) {
  return request({
    url: "/mgr/calendar/update",
    method: "post",
    data,
  });
}

export function getScheduleList(userID) {
  return request({
    url: `/mgr/calendar/list/${userID}`,
    method: "post",
  });
}

export function confirmTask(data) {
  return request({
    url: "/mgr/calendar/confirm",
    method: "post",
    data,
  });
}
